import { type useTranslation } from 'react-i18next';
import { type ComboboxOption } from './types';

type TranslationFunction = ReturnType<typeof useTranslation>['t'];

export const translateOptionLabel = (
  translate: TranslationFunction,
  option: Pick<ComboboxOption, 'label' | 'ns'>
): string => String(translate(option.label, option.ns ? { ns: option.ns } : {}));

export const translateOptionDescription = (
  translate: TranslationFunction,
  option: Pick<ComboboxOption, 'description' | 'ns'>
): string | undefined =>
  option.description
    ? String(translate(option.description, option.ns ? { ns: option.ns } : {}))
    : undefined;

export const getSelectedValues = (
  isMultiple: boolean,
  value: string | string[] | undefined,
  internalValue: string | string[]
): string | string[] => {
  if (isMultiple) {
    if (Array.isArray(value)) return value;
    if (Array.isArray(internalValue)) return internalValue;
    return [];
  }

  if (typeof value === 'string') return value;
  if (typeof internalValue === 'string') return internalValue;
  return '';
};
